<template>
  <app-dialog
    v-model="openModel"
    content-class="dialogGuaranteeTrafficAccident guaranteeModal"
    @onClose="$emit('onClose')"
  >
    <template v-slot:title>
      <h1 class="dialogGuaranteeTrafficAccident-title">
        交通事故によるケガの保障
      </h1>
    </template>
    <v-card class="dialogGuaranteeTrafficAccident-content">
      <v-card-text class="dialogGuaranteeTrafficAccident-content">
        <div class="his-tbl_wrapper">
          <table>
            <thead>
              <tr>
                <th colspan="5">保障内容</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th></th>
                <th>Ｇ型</th>
                <th>Ｍ型</th>
                <th>Ｎ型</th>
              </tr>
              <tr>
                <td>１口<br />あたりの<br />保障額</td>
                <td data-label="Ｇ型">
                  <table>
                    <tbody>
                      <tr>
                        <th>入院</th>
                        <td>１，５００円/日</td>
                      </tr>
                      <tr>
                        <th rowspan="3">手術</th>
                        <td>(外来)<br />入院保険金日額の１０倍</td>
                      </tr>
                      <tr>
                        <td>(入院)<br />入院保険金日額の２０倍</td>
                      </tr>
                      <tr>
                        <td>(重大)<br />入院保険金日額の４０倍</td>
                      </tr>
                      <tr>
                        <th>通院</th>
                        <td>１，０００円/日</td>
                      </tr>
                    </tbody>
                  </table>
                </td>
                <td data-label="Ｍ型">
                  <table>
                    <tbody>
                      <tr>
                        <th>死亡</th>
                        <td>１００万円</td>
                      </tr>
                      <tr>
                        <th>後遺障害</th>
                        <td>障害の程度に応じて<br />４万円～１００万円</td>
                      </tr>
                    </tbody>
                  </table>
                </td>
                <td data-label="Ｎ型">
                  <table>
                    <tbody>
                      <tr>
                        <th>後遺障害</th>
                        <td>障害の程度に応じて<br />４万円～１００万円</td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              <tr>
                <td>ご加入条件</td>
                <td data-label="Ｇ型">単独加入が可能</td>
                <td data-label="Ｍ型">
                  M型・N型のいずれか一方のみ単独加入が可能
                </td>
                <td data-label="Ｎ型">
                  M型・N型のいずれか一方のみ単独加入が可能
                </td>
              </tr>
              <tr>
                <td>口数の制限</td>
                <td data-label="Ｇ型">1～10口の範囲内</td>
                <td data-label="Ｍ型">1～20口の範囲内</td>
                <td data-label="Ｎ型">1～20口の範囲内</td>
              </tr>
            </tbody>
          </table>
        </div>
      </v-card-text>
    </v-card>
  </app-dialog>
</template>

<script>
export default {
  name: 'DialogGuaranteeReduceIncome',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    openModel: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>

<style lang="scss">
.dialogGuaranteeTrafficAccident {
  width: 690px;
  max-width: 700px;
  &-content {
    &.v-card__text {
      padding: 0 30px 20px;
    }
  }
  &-title {
    font-size: 18px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    text-align: center;
    color: #333;
    margin-top: 15px;
    margin-bottom: 5px;
    width: 100%;
  }
}
</style>
